import { getAllRows } from "../supabaseRealtime";

export const getSectores = async () => getAllRows("sectores");

// SE AGREGAN O ELIMINAN SECTORES DIRECTAMENTE DESDE LA DB
